<template>
    <div class="content work_wrapper">
        <v-row class="search_box">
            <v-col>
              <searchBar></searchBar>
            </v-col>
        </v-row>
        <div class="report_center_wrapper">
            <div class="flex_style betw mart24 marb24">
                <div class="md_title">{{title}}-报告分析</div>
                <div><v-btn @click="goEmail">邮件</v-btn></div>
            </div>
            <div class="bread_route margbsm hand" @click="goBack">返回分析报告主页</div>
            <div class="center_content">
                <div class="md_title marb24">下载进度页</div>
                <v-row class="flex_style left">
                    <v-col>
                        <div v-if="progressNum<100">
                            <v-progress-linear
                            v-model="progressNum"
                            color="green"
                            height="25"
                            >
                            <template v-slot:default="{ value }">
                                <strong>{{ Math.ceil(value) }}%</strong>
                            </template>
                            </v-progress-linear>
                        </div>
                        <div class="marg8">{{summary}}</div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn color="primary" @click="reDownloadFile('2')">重新下载word</v-btn>
                        <v-btn color="primary" class="marl10" @click="reDownloadFile('1')">重新下载pdf</v-btn>
                    </v-col>
                </v-row>
                <div class="reportList_wrapper">
                    <v-row>
                        <v-col sm="12" md="4" class="item_wrapper" v-for="(item,index) in reportList" :key="index">
                            <div class="item">
                                <div class="tit">{{info.title}}</div>
                                <div class="time"><b v-if="item.type =='1'">Pdf</b><b v-if="item.type =='2'">Word</b></div>
                                <div class="time">{{timeFormat(item.createdAt)}}</div>
                                <!-- <div class="desc">{{item.summary}}</div> -->
                                <div class="actions">
                                    <div class="btn" @click="reload1(item)">重新下载</div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </div>        
</template>
<script>
import searchBar from "@/components/widgets/searchBar.vue";
import {mapActions} from 'vuex';
export default {
    data() {
        return {
            selectKeys: [],
            data: [

            ],
            email: '',
            reportId: '',
            progressNum: 0,
            pdfId: '',
            info: {},
            timer: '',
            summary: '',
            reportList: [],
            wordInfoId: '',
            pdfInfoId: '',
            title: ''
        }
    },
    components: {
        searchBar
    },
    created() {
        this.reportId = this.$route.params.id
        this.title = this.$route.query.title
        // this.getFile()
        this.getList()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        ...mapActions('report',['downLoadFile','getProgress','reloadFile','getDownLoadList']),
        timeFormat(unixTime) {
            let date = new Date(unixTime);
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            let D = date.getDate() + ' ';
            let h = date.getHours() + ':';
            let m = date.getMinutes() + ':';
            let s = date.getSeconds();
            return Y+M+D+h+m+s;
        },
        goEmail() {
            this.$router.push({
                path: '/report/email/'+ this.reportId,
                query: {
                    title: this.title
                }
            })
        },
        goBack() {
            this.$router.push({
                path: '/report'
            })
        },
        getFile() {
            let data = {
                url: this.reportId,
                data1: {
                    params: {
                        reportId: this.reportId,
                        type: ''
                    }
                }
            }
            let _this = this
            this.downLoadFile({data: data,handle(res) {
                _this.pdfId = res.reportPdfId
                if(res.reportPdfList.length>0) {
                    _this.progressNum = res.reportPdfList[0].percent*100
                }else {
                    _this.progressNum = 0
                }
                _this.info = res.report
                if(_this.progressNum<100) {
                    _this.getPercent()
                }
            }})
        },
        getList() {
            let data = {
                url: this.reportId,
                data1: {
                    params: {
                        reportId: this.reportId,
                    }
                }
            }
            let _this = this
            this.getDownLoadList({data: data,handle(res) {
                 _this.reportList = res.reportPdfList
            }})
        },
        getPercent() {
            let data = {
                url: this.pdfId,
                data1: ''
            }
            let _this = this
            this.getProgress({data:data,handle(res) {
                if(res.success) {
                    let info = JSON.parse(res.message)
                    _this.progressNum = info.percent*100
                    _this.summary = info.summary
                    if(_this.progressNum < 100) {
                        _this.timer = setInterval(() => {
                            _this.getProgress({data:data,handle(res) {
                                if(res.success) {
                                    let info = JSON.parse(res.message)
                                    _this.progressNum = info.percent*100
                                    _this.summary = info.summary
                                    if(_this.progressNum>=100) {
                                        clearInterval(_this.timer)
                                        _this.reload()
                                        // window.open(path)
                                        _this.getList()
                                    }
                                }
                            }})
                        }, 2000);
                    }
                }
            }})
        },
        reload(val) {
            let id = ''
            if(val) {
                id = val == '1'?this.pdfInfoId: this.wordInfoId
            }else {
                id = this.pdfId
            }
            let path = 'https://www.iprdb.com/report/'+ id +'/load.html'
            let a = document.createElement('a');
            a.href = path;
            a.click();
        },
        reload1(item) {
            let type = item.type
            if(type == '1'&&this.pdfInfoId) {
              this.reload(type)
            }else if(type=='2' &&this.wordInfoId) {
               this.reload(type)
            }else {
                let data = {
                    url: this.reportId,
                    data1: {
                        params: {
                            type: type
                        }
                    }
                }
                let _this = this
                this.reloadFile({data:data,handle(res) {
                    if(res.success) {
                        _this.pdfId = res.message
                        if(type == '1') {
                            _this.pdfInfoId = res.message
                        }else {
                            _this.wordInfoId = res.message
                        }
                        _this.reload(type)
                    }
                }})
            }
        },
        reDownloadFile(type) {
            console.log('type',type)
            let data = {
                url: this.reportId,
                data1: {
                    params: {
                        type: type
                    }
                }
            }
            let _this = this
            this.progressNum = 0
            this.reloadFile({data:data,handle(res) {
                if(res.success) {
                    _this.pdfId = res.message
                    if(type == '1') {
                        _this.pdfInfoId = res.message
                    }else {
                        _this.wordInfoId = res.message
                    }
                    _this.getPercent()
                }
            }})
        }
    }
}
</script>